import axios from "axios";
import TokenService from "./token.service";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

const decodeToken = (token) => {
  try {
    const payload = token.split('.')[1]; // Extraire la partie utile du JWT (payload)
    return JSON.parse(atob(payload));    // Décoder le payload en Base64 et le parser en JSON
  } catch (error) {
    console.error('Invalid token:', error);
    return null;
  }
};

const isTokenExpired = (token) => {
  const decodedToken = decodeToken(token);
  if (!decodedToken || !decodedToken.exp) {
    return true; // Si le token n'est pas valide ou ne contient pas la clé 'exp', il est considéré comme expiré
  }

  const currentTime = Math.floor(Date.now() / 1000);  // Obtenir l'heure actuelle en secondes (timestamp UNIX)
  return decodedToken.exp < currentTime;  // Retourne true si le token est expiré
};

instance.interceptors.request.use(
  (config) => {
    const token = TokenService.getAccessToken();
    if (token) {
      config.headers["Authorization"] = 'Bearer ' + token;  // for Spring Boot back-end
    }else{
      config.headers["Authorization"] = 'Bearer ' + TokenService.getRefreshToken();
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
instance.interceptors.response.use(
  (res) => { return res; },
  async (err) => 
  {
    const originalConfig = err.config;
    if (originalConfig.url !== "/login" && err.response) {
      const token = TokenService.getAccessToken();
      if(isTokenExpired(token)) {
        TokenService.deleteAccessToken();
        window.location.href = "/login";
        return; 
      }  // Access Token was expired
      console.log(err);
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;
        try {
          const rs = await instance.post("/refresh", {
            refresh_token: TokenService.getRefreshToken(),
          });
          const { accessToken } = rs.data;
          TokenService.updateAccessToken(accessToken);
          return instance(originalConfig);
        } catch (_error) {
          return Promise.reject(_error);
        }
      }
    }
    return Promise.reject(err);
  }
);

export default instance;